module.exports = __webpack_public_path__ + "img/outline.d91f5053.svg";